import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { getCmsLayout, useCmsStore } from "@/data/cmsStore";
import { useI18n } from "@/i18n/I18nProvider";

const MentionsLegalesPage = () => {
  const { lang, isRtl } = useI18n();
  const layouts = useCmsStore(state => state.layouts);
  const layout = layouts["global"] || getCmsLayout("global");
  
  const [content, setContent] = useState<Record<string, string>>({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const legalSection = layout.find((s: any) => s.id === "legal_pages");
    if (legalSection && legalSection.content) {
      setContent(legalSection.content);
    }
  }, [layout]);

  const renderSection = (keyPrefix: string) => {
    if (content[`${keyPrefix}_visible`] === "false") return null;
    
    const titleKey = `${keyPrefix}_title_${lang}`;
    const title = content[titleKey] || content[`${keyPrefix}_title_fr`] || keyPrefix;
    const htmlContent = content[`${keyPrefix}_content_${lang}`] || content[`${keyPrefix}_content_fr`] || "";

    return (
      <section className="mb-16 pb-12 border-b border-border/50 last:border-0 last:mb-0 last:pb-0">
        <h2 className="text-3xl font-display font-bold text-foreground mb-8 relative inline-block">
          {title}
          <div className="absolute -bottom-2 left-0 w-1/3 h-1 bg-primary rounded-full"></div>
        </h2>
        <div 
          className="prose prose-lg dark:prose-invert max-w-none text-foreground/80 space-y-4"
          dangerouslySetInnerHTML={{ __html: htmlContent }} 
        />
      </section>
    );
  };

  const displayMode = content["display_mode"] || "unified";

  return (
    <div className="min-h-screen bg-background flex flex-col font-body" dir={isRtl ? "rtl" : "ltr"}>
      <Navbar />
      <main className="flex-1 container max-w-4xl px-4 py-24 md:py-32">
        <h1 className="text-4xl md:text-5xl font-display font-extrabold text-primary mb-12 text-center md:text-start">
          {displayMode === "unified" 
            ? (lang === 'ar' ? 'الشروط والمعلومات القانونية' : lang === 'zgh' ? 'ⵉⵙⵓⵔⴰⴼ ⴷ ⵉⵏⵖⵎⵉⵙⵏ ⵉⵣⵔⴼⴰⵏⵏ' : 'Conditions et mentions légales')
            : (content[`mentions_title_${lang}`] || content["mentions_title_fr"] || 'Mentions Légales')
          }
        </h1>

        <div className="bg-card border rounded-2xl p-6 md:p-12 shadow-sm">
          {renderSection("mentions")}
          {displayMode === "unified" && renderSection("conditions")}
          {displayMode === "unified" && renderSection("politique")}
          
          {content["mentions_visible"] === "false" && (displayMode === "separated" || (content["conditions_visible"] === "false" && content["politique_visible"] === "false")) && (
            <div className="text-center py-12 text-muted-foreground italic">
              {lang === 'ar' ? 'هذه الصفحة قيد الصيانة.' : lang === 'zgh' ? 'ⵜⴰⵙⵏⴰ ⴰⴷ ⵜⵍⵍⴰ ⴳ ⵓⵙⴳⴳⴷ.' : 'Cette page est en cours de maintenance.'}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
